module.exports = __webpack_public_path__ + "img/undraw_select_house_qbag.563a02f5.svg";